module.exports = __webpack_public_path__ + "img/2.e26f10f5.jpg";